import { createSelector } from 'reselect';
import dayjs from 'dayjs';

const selectSettingsState = (state) => state.settingsReducer;
export const getCustomerPortal = () =>
  createSelector(selectSettingsState, (state) => state.customerPortal);
export const getCustomerBill = () => createSelector(selectSettingsState, (state) => state.bill);

export const getCustomerInvoices = () =>
  createSelector(selectSettingsState, (state) => state.invoices);
export const getCustomerPlan = () => createSelector(selectSettingsState, (state) => state.plans);
export const getSubscriptionStatus = () =>
  createSelector(selectSettingsState, (state) => state.subscriptionStatus);
export const getSubscriptionLoading = () =>
  createSelector(selectSettingsState, (state) => state.subscriptionLoading);
export const getSubscriptionSubmitting = () =>
  createSelector(selectSettingsState, (state) => state.subscriptionSubmitting);
export const getSubscriptionError = () =>
  createSelector(selectSettingsState, (state) => state.subscriptionError);
export const getCustomerProducts = () =>
  createSelector(selectSettingsState, (state) => state.products);
export const getProductsLoading = () =>
  createSelector(selectSettingsState, (state) => state.productsLoading);
export const getProductsError = () =>
  createSelector(selectSettingsState, (state) => state.productsError);
export const getPlansLoading = () =>
  createSelector(selectSettingsState, (state) => state.plansLoading);

export const getAccountsStaff = () => createSelector(selectSettingsState, (state) => state.accounts);
export const getAccountsWorkers = () => {
  return createSelector(selectSettingsState, (state) => {
    return state.accounts.map((account) => account.poltrona.idpoltrona);
  });
}
export const getMyAccountStaff = () =>
  createSelector(selectSettingsState, (state) => state.myAccount);
export const getShowTokenExpiredModal = () =>
  createSelector(selectSettingsState, (state) => state.showTokenExpiredModal);
export const getTokenExpiredModalReason = () =>
  createSelector(selectSettingsState, (state) => state.tokenExpiredModalReason);
